export default "__VITE_ASSET__a5db363d__"